module.exports = __webpack_public_path__ + "static/media/raspberry.0a268a02.jpg";